import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import DealsPage from "./DealsPage";
import DealsKanbanPage from "./DealsKanbanPage";
import PipelinePage from "../pipeline/PipelinePage";

import styles from "./DealsHubPage.module.css";

import { getUserRole } from "../../../../shared/lib/auth/authHelper";
import { getUserPermissions } from "../../../../shared/lib/auth/authHelper";

const TABS = {
  table: "table",
  kanban: "kanban",
  pipeline: "pipeline",
};

export default function DealsHubPage() {
  const { t } = useTranslation();
  const location = useLocation();
  const canUpdateDeals = getUserPermissions()?.includes("deals.update");
  const requestedTab = useMemo(() => {
    const view = new URLSearchParams(location.search).get("view");
    return Object.values(TABS).includes(view) ? view : TABS.table;
  }, [location.search]);
  const [tab, setTab] = useState(requestedTab);

  const roleId = useMemo(() => {
    const r = getUserRole();
    const n = Number(r);
    return Number.isFinite(n) ? n : null;
  }, []);

  const isAdmin = useMemo(() => roleId === 1 || roleId === 2, [roleId]);

  useEffect(() => {
    if (tab === TABS.pipeline && !isAdmin) setTab(TABS.table);
  }, [tab, isAdmin]);

  useEffect(() => {
    if (requestedTab === TABS.pipeline && !isAdmin) {
      setTab(TABS.table);
      return;
    }
    if (requestedTab === TABS.kanban && !canUpdateDeals) {
      setTab(TABS.table);
      return;
    }
    setTab(requestedTab);
  }, [requestedTab, isAdmin, canUpdateDeals]);

  return (
    <div className={styles.page}>
      <div className={styles.rightTabsRow}>
        <button
          data-academy="deals-tab-table"
          type="button"
          className={`${styles.rightTabBtn} ${
            tab === TABS.table ? styles.rightTabActive : ""
          }`}
          onClick={() => setTab(TABS.table)}
        >
          {t("deals_tab_list", { defaultValue: "List" })}
        </button>

        {canUpdateDeals && (
          <button
            data-academy="deals-tab-kanban"
            type="button"
            className={`${styles.rightTabBtn} ${
              tab === TABS.kanban ? styles.rightTabActive : ""
            }`}
            onClick={() => setTab(TABS.kanban)}
          >
            {t("deals_tab_board", { defaultValue: "Board" })}
          </button>
        )}

        {isAdmin && (
          <button
            data-academy="deals-tab-pipeline"
            type="button"
            className={`${styles.rightTabBtn} ${
              tab === TABS.pipeline ? styles.rightTabActive : ""
            }`}
            onClick={() => setTab(TABS.pipeline)}
          >
            {t("pipeline", { defaultValue: "Pipeline" })}
          </button>
        )}
      </div>

      <div className={styles.contentWrap}>
        {tab === TABS.table && <DealsPage />}
        {tab === TABS.kanban && <DealsKanbanPage />}
        {tab === TABS.pipeline && isAdmin && <PipelinePage />}
      </div>
    </div>
  );
}
